<template>
    <div class="userGuideContainer">
        <h2 id="createTitle">插件使用说明</h2>
        <div class="guideSection">
            <h2>创建库库物体</h2>
            <ul>
                <li>创建面板选择"KukuLib"</li>
                <li>在场景中创建基本物体</li>
            </ul>
            <video 
                :src="require('@/assets/video/use_create.mp4')" 
                controls 
                preload="none"
                :poster="require('@/assets/video/use_create_00016.jpg')"
                @ended="onVideoEnded">
                您的浏览器不支持 HTML5 视频标签。
            </video>
        </div>
        <div class="guideSection">
            <h2>调用资源</h2>
            <ul>
                <li>选择创建的基本物体，进入"修改面板"</li>
                <li>点击修改面板的"选择"按钮，调出资源浏览器</li>
                <li>选择资源列表里的卡片中“选择”按钮，可直接将选择模型替换成资源模型</li>
            </ul>
            <video 
                src="@/assets/video/use_replace.mp4" 
                controls 
                preload="none"
                :poster="require('@/assets/video/use_replace_00000.jpg')">
                您的浏览器不支持 HTML5 视频标签。
            </video>
        </div>
        <div class="guideSection">
            <h2>多个模型同步替换</h2>
            <ul>
                <li>关联复制的物体，会同步批量进行替换</li>
            </ul>
            <video 
                src="@/assets/video/use_instace.mp4" 
                controls
                preload="none"
                :poster="require('@/assets/video/use_instace_00000.jpg')">
                您的浏览器不支持 HTML5 视频标签。
            </video>
        </div>
    </div>
</template>

<script>
export default{
    name: 'PluginsList' 
}

</script>

<style>

.userGuideContainer{
    width: fit-content;
    margin: 0 auto;
}

#createTitle{
    padding: 24px;
    color: #45B5B5;
    background-color: rgb(250, 250, 250);
    border-radius: 12px;
}

.guideSection{
    margin: 100px auto;
    margin-top: 12px;
    border-radius: 12px;
    background-color: rgb(250, 250, 250);
    padding: 48px;
    display: flex;
    flex-direction: column;
}

.guideSection h2{
    font-size: 20px;
    padding-bottom: 14px;
}

.guideSection li{
    margin-left: 16px;
    list-style-type: decimal;
    line-height: 24px;
}

.guideSection video{
    margin-top: 14px;
    margin-bottom: 48px;
    width: 720px;
    height: 405px;
    border-radius: 12px;
}

</style>